

import React, {useEffect, useState} from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import {Container} from "@material-ui/core";
import {experiments_view} from "../../../service/apis";
import auth from "../../../service/Auth";
import {aggr_keys, header_exp_config} from "../components/headers_config";
import VChart from "../viz/bar-chart/VChart";
import Divider from "@mui/material/Divider";




export default function Project(props){


    const [init, setInit] = useState(false);
    const [project, setProjectName] = useState(false);
    const [aggregations, setAggregations] = useState(false);
    const [total, setTotal] = useState(0);

    useEffect(function(){


        if(!init){

            if(props.match.params.project_name !== undefined){


                setProjectName(props.match.params.project_name)
                let projectPost = {"page":1,"pageSize":10,"fields":["Owner","ExperimentID"],"filtered":[{id: "project", value: [props.match.params.project_name]}],"sorted":[],
                    "aggregates":aggr_keys.filter(s => s !== "project")};

                experiments_view(auth.getToken(), window.config.api_endpoint, JSON.stringify(projectPost) ).then(r => r.json()).then(json => {
                    let data = json["_meta"];
                    setAggregations(data.aggregates);
                    setTotal(data.totalItems);
                })
                setInit(true);
            }
        }
    })


    const renderCharts = () => {


        if(aggregations){

            return Object.keys(aggregations).map(function(keyItem){

                let values = aggregations[keyItem];
                let data = [];
                if(values!== undefined)
                {
                    let item = values[0];
                    Object.keys(values[0]).forEach(function(k){
                        let val = item[k];
                        let label = (k === "") ? "NA" : k
                        data.push({"key": label, "d": label, "value": val})
                    });

                }


                let label = (header_exp_config.find(s => s.key === keyItem) !== undefined)
                    ? header_exp_config.find(s => s.key === keyItem).label
                    : keyItem;

                return <React.Fragment>
                    <Grid item lg={4}>
                        <Box p={2}>
                            <Typography variant={"h6"} color={"#2171b5"}>{label}</Typography>
                            <VChart  initData={data}
                                     variable={keyItem}
                                     data={data}
                                     handleFilter={() => console.log("filter")}
                                     selected = {[]}/>
                        </Box>
                    </Grid>


                </React.Fragment>


            })


        }

    }



    return <div style={{width: "100%",height: "100%", float: "left", padding: "3%"}}>
            <Typography variant={"h5"} textAlign={"center"}>Project: {props.match.params.project_name}</Typography>
            <Typography variant={"subtitle1"} textAlign={"center"}>This project includes {total} experiments belonging to
                {(aggregations && aggregations["Owner"][0]!== undefined )
                    ? " " + Object.keys(aggregations["Owner"][0]).length + " "
                    : "0 " }
                groups

            </Typography>
            <Box p={1}>
                <Typography variant={"subtitle2"} textAlign={"center"}>Please, bear in mind that the numbers below may depend on your data visibility permissions</Typography>
            </Box>
            <div className="borderExperiment">
            <Grid container justifyContent={"center"} alignContent={"center"}>
                {renderCharts()}
            </Grid>
</div>
    </div>
}